<main class="flex min-h-screen items-center justify-center px-4 py-8">
  <div class="flex w-full max-w-md flex-col gap-6">
    <app-logo [widthInPx]="120" />

    <section hlmCard aria-labelledby="partner-verify-title">
      <div hlmCardHeader>
        <h1 hlmCardTitle id="partner-verify-title">E-Mail-Adresse bestätigen</h1>
      </div>
      <div hlmCardContent class="space-y-6">
        @switch (state()) {
          @case ('checking') {
            <hlm-skeleton class="h-16 w-full" aria-busy="true" aria-label="Link wird geprüft" />
          }
          @case ('confirmed') {
            <div hlmAlert role="status">
              <ng-icon name="lucideCircleCheck" />
              <p hlmAlertTitle>Deine E-Mail-Adresse ist bestätigt</p>
              <p hlmAlertDescription>Melde dich jetzt mit deinem Passwort an.</p>
            </div>
            <a hlmBtn routerLink="/partner/login" class="w-full">Zur Anmeldung</a>
          }
          @case ('failed') {
            <div hlmAlert variant="destructive" role="alert">
              <ng-icon name="lucideTriangleAlert" />
              <p hlmAlertTitle>{{ error() }}</p>
              <p hlmAlertDescription>
                Schon bestätigt?
                <a routerLink="/partner/login" class="underline underline-offset-4">Anmelden</a>.
                Sonst kannst du dir beim Anmelden einen neuen Link schicken lassen.
              </p>
            </div>
          }
        }
      </div>
    </section>
  </div>
</main>
